export default __webpack_public_path__ + "images/kz-7194851eb720d3fdb3ad7c94eade695c.svg";